import React from 'react';
import { ShareButtons } from './ButtonList';
import './style.scoped.scss';
import { FaShare } from 'react-icons/fa';
import clipboardCopy from 'clipboard-copy';
import { USER, notification } from '../../assets/constants/strings';
import { UpdateUserUsage } from '../../store/User/userActions';
import { connect } from 'react-redux';

const mapDispatchToProps = { UpdateUserUsage };

const connector = connect(null, mapDispatchToProps);

const ShareBtn = ({
  currentDocument,
  user,
  isSummary,
  currentPage,
  UpdateUserUsage,
}) => {
  const disclaimer =
    'This is Beta release of summarisation using generative Ai.';

  const handleClick = (e, type) => {
    if (user.remainingShares <= 0) {
      return notification(
        'info',
        'You have reached your amount of pages shared for the current period.'
      );
    } else UpdateUserUsage(USER.USAGE.SHARES);

    switch (type) {
      case 'email':
        handleEmail();
        break;
      case 'link':
        handleCopy(type);
        break;
      case 'page':
        handleCopy(type);
        break;
      case 'download':
        handleDownload(e);
        break;
      case 'print':
        handlePrint(e);
        break;

      default:
        break;
    }
  };

  const handleEmail = () => {
    const pageURL = `Document Source: ${window.location.href}`;
    const subject = `Document Title: ${currentDocument.title}`;
    const title = isSummary
      ? `Summary of ${currentDocument.title}`
      : `Document Title: ${currentDocument.title}\n\nPage: ${currentPage.title}`;

    const content = copyContent();

    const body = isSummary
      ? `${title}\n\n${disclaimer}\n\n${content}\n\n${pageURL}\n\n${user.displayName}`
      : `${title}\n\n${content}\n\n${pageURL}\n\n${user.displayName}`;

    const mailtoURL = `mailto:?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoURL;
  };

  const handleCopy = (type) => {
    if (type === 'link') copyToClipboard(window.location.href, type);
    else {
      const content = copyContent();
      copyToClipboard(content, type);
    }
  };

  const copyContent = () => {
    const content = document.getElementById('content');

    let text = '';
    if (content) {
      const range = document.createRange();
      range.selectNode(content);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      // Get the selected text and update the selectedText state
      text = selection.toString();
    }
    return text;
  };

  const copyToClipboard = (text, type) => {
    clipboardCopy(text)
      .then(() => {
        if (type === 'link')
          notification('success', 'Page link copied to clipboard.');
        else notification('success', 'Page content copied to clipboard.');
      })
      .catch((error) => {
        console.error('Copy to clipboard failed: ', error);
      });
  };

  const handleDownload = (e) => {
    e.preventDefault();
    const element = document.createElement('a');
    const blob = new Blob([convertToWord()], {
      type: 'application/msword',
    });
    const url = URL.createObjectURL(blob);
    element.href = url;

    element.download = isSummary
      ? `Summary of ${currentDocument.title}.doc`
      : `${currentPage.title}.doc`;

    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    URL.revokeObjectURL(url);
  };

  const convertToWord = () => {
    const header = `<!DOCTYPE html><html><head><meta charset="UTF-8"></head><body>`;
    const footer = `</body></html>`;
    const docSource = `<p>Document Source: <a href=${window.location.href}>Click Here</a></p>`;

    const contentElement = document.getElementById('content');

    const contentToDownload = contentElement.innerHTML;

    const title = isSummary
      ? `Summary of ${currentDocument.title}`
      : `<h2>Document Title: ${currentDocument.title}</h2><h3>Page: ${currentPage.title}</h3>`;

    return isSummary
      ? `${header}<h2>${title}</h2><p>${disclaimer}</p>${contentToDownload}${docSource}${footer}`
      : `${header}<h2>${title}</h2>${contentToDownload}${docSource}${footer}`;
  };

  const handlePrint = (e) => {
    e.preventDefault();
    const contentElement = document.getElementById('content');

    if (contentElement) {
      const contentToPrint = contentElement.innerHTML;

      const title = isSummary
        ? `Summary of ${currentDocument.title}`
        : `<h2>Document Title: ${currentDocument.title}</h2><h3>Page: ${currentPage.title}</h3>`;

      const printWindow = window.open();
      if (printWindow) {
        printWindow.document.open();

        if (isSummary)
          printWindow.document.write(
            `<html><head></head><body><h2>${title}</h2><p>${disclaimer}<p/>`
          );
        else
          printWindow.document.write(
            `<html><head></head><body><h2>${title}</h2>`
          );

        printWindow.document.write(contentToPrint);
        printWindow.document.write('</body></html>');
        printWindow.document.close();

        printWindow.print();
        printWindow.close();
      }
    }
  };

  return (
    <div className='dropdown dropdownWrapper'>
      <button
        className='btn dropdown-toggle dropdownButton'
        type='button'
        id='dropdownMenuButton'
        data-toggle='dropdown'
        aria-haspopup='true'
        aria-expanded='false'
      >
        <span className='mr-2'>
          <FaShare />
        </span>
        Share
      </button>
      <div
        className='dropdown-menu dropdownList fixedPosition'
        aria-labelledby='dropdownMenuButton'
      >
        {ShareButtons.map((item, index) => (
          <div
            className='dropdown-item dropdownItems'
            key={index}
            onClick={(e) => handleClick(e, item.type)}
          >
            <span className='mr-2'>{item.icon}</span>
            {item.title}
          </div>
        ))}
      </div>
    </div>
  );
};

export default connector(ShareBtn);
